const dev = !process.env.NODE_ENV || process.env.NODE_ENV === 'development'

if (dev) {
	console.log('Running in debug mode')
}

module.exports = dev